(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[209],{

/***/ "gfEP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/product-breadcrumb-line/ProductBreadcrumbLine.jsx







var __jsx = react_default.a.createElement;











var ProductBreadcrumbLine_BreadcrumbCell = function BreadcrumbCell(_ref) {
  var className = _ref.className,
      isCurrent = _ref.isCurrent,
      label = _ref.label,
      url = _ref.url;
  return url ? __jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('underline', className),
    url: url
  }, isCurrent ? {
    'aria-current': 'location'
  } : null), __jsx("span", {
    className: "max-w-full truncate"
  }, label)) : __jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('font-bold', className)
  }, __jsx("span", {
    className: "max-w-full truncate"
  }, label));
};

var ProductBreadcrumbLine_ProductBreadcrumbLine = function ProductBreadcrumbLine(_ref2) {
  var countryPage = _ref2.countryPage,
      originalUrl = _ref2.originalUrl,
      regionPage = _ref2.regionPage,
      resort = _ref2.resort;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      breadcrumb = _usePageContext.breadcrumb,
      pageRegion = _usePageContext.pageRegion,
      pageCountry = _usePageContext.pageCountry,
      pageType = _usePageContext.pageType;

  var _useRouter = Object(router["useRouter"])(),
      asPath = _useRouter.asPath;

  var origin = new URI_default.a(originalUrl).origin().toString();
  var _b2cPagesService$PAGE = dist["b2cPagesService"].PAGE_TYPES,
      DESTINATION = _b2cPagesService$PAGE.DESTINATION,
      DESTINATION_CRUISE = _b2cPagesService$PAGE.DESTINATION_CRUISE,
      DESTINATION_TOUR = _b2cPagesService$PAGE.DESTINATION_TOUR,
      DESTINATION_TRAVEL = _b2cPagesService$PAGE.DESTINATION_TRAVEL,
      LANDING = _b2cPagesService$PAGE.LANDING,
      LANDING_MICE = _b2cPagesService$PAGE.LANDING_MICE,
      OFFER = _b2cPagesService$PAGE.OFFER,
      RESORT_PAGE = _b2cPagesService$PAGE.RESORT;
  var breadcrumbItems = [{
    label: dist["constants"].WEBSITE_NAME,
    url: '/'
  }];

  switch (pageType) {
    case LANDING:
    case LANDING_MICE:
    case OFFER:
      if (breadcrumb) {
        breadcrumbItems.push.apply(breadcrumbItems, Object(toConsumableArray["a" /* default */])(breadcrumb));
      }

      break;

    case DESTINATION:
    case DESTINATION_CRUISE:
    case DESTINATION_TOUR:
    case DESTINATION_TRAVEL:
      var destinationItems = [(regionPage === null || regionPage === void 0 ? void 0 : regionPage.pageRegion) ? {
        label: regionPage.pageRegion.breadcrumbLabel,
        url: regionPage.url
      } : null, pageRegion && pageCountry ? {
        label: pageCountry.breadcrumbLabel,
        url: ''
      } : null, pageRegion && !pageCountry ? {
        label: pageRegion.breadcrumbLabel,
        url: ''
      } : null];
      breadcrumbItems.push.apply(breadcrumbItems, Object(toConsumableArray["a" /* default */])(destinationItems.filter(Boolean)));
      break;

    case RESORT_PAGE:
      var resortItems = [(regionPage === null || regionPage === void 0 ? void 0 : regionPage.pageRegion) ? {
        label: regionPage.pageRegion.breadcrumbLabel,
        url: regionPage.url
      } : null, (countryPage === null || countryPage === void 0 ? void 0 : countryPage.pageCountry) ? {
        label: countryPage.pageCountry.breadcrumbLabel,
        url: countryPage.url
      } : null, resort ? {
        label: resort.name,
        url: ''
      } : null];
      breadcrumbItems.push.apply(breadcrumbItems, Object(toConsumableArray["a" /* default */])(resortItems.filter(Boolean)));
      break;

    default:
  }

  if (breadcrumbItems.length <= 1) {
    return null;
  }

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-Breadcrumb"
  }, [{
    type: 'application/ld+json',
    innerHTML: JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@id': item.url ? encodeURIComponent(origin + item.url) : encodeURIComponent(new URI_default.a(origin + asPath).readable()),
            name: item.label
          }
        };
      })
    })
  }].map(function (script, idx) {
    return __jsx("script", {
      key: idx,
      type: script.type,
      dangerouslySetInnerHTML: {
        __html: script.innerHTML
      }
    });
  }), __jsx("nav", {
    "aria-label": "breadcrumbs",
    className: "flex items-end sm:overflow-x-visible scroll-x scrollbar-hidden",
    "data-testid": "breadcrumb"
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].HOME,
    width: "0.75rem"
  }), __jsx("ol", {
    className: "flex gap-5 items-center leading-1 pe-20 sm:pe-0 "
  }, breadcrumbItems.map(function (item, i) {
    return __jsx("li", {
      className: "flex gap-5 items-center",
      key: i
    }, __jsx(ProductBreadcrumbLine_BreadcrumbCell, Object(esm_extends["a" /* default */])({}, item, {
      className: "text-black text-12 whitespace-nowrap",
      isCurrent: i === breadcrumbItems.length - 1
    })), i < breadcrumbItems.length - 1 && __jsx("span", {
      className: "leading-0",
      "aria-hidden": "true"
    }, ">"));
  }))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-breadcrumb/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductBreadcrumbLine_ProductBreadcrumbLine);

/***/ })

}]);